import React, { Component } from 'react';
import { Modal, Radio, message } from 'antd';
import API_URL from '../../../../common/url';
import addToDownloadSite from '../../../shared/addToDownloadSite';

const RadioGroup = Radio.Group;
const valueMap = {
    requirement: 'PLAN_REQ',
    requirementDetail: 'PLAN_REQ_DETAIL',
};

class ExportModal extends Component {
    state = {
        visible: false,
    }

    show = (searchParams) => {
        this.setState({
            exportType: '',
            searchParams,
            visible: true,
        });
    }

    handleOk = () => {
        const { exportType, searchParams } = this.state;
        if (!exportType) {
            message.warning('请选择要导出内容');
            return;
        }

        const params = { exportType, ...searchParams };
        const url = API_URL.member.exportRequirement;

        addToDownloadSite (params, url, valueMap[exportType]); 

        this.setState({ visible: false });
    }

    handleCancel = () => {
        this.setState({ visible: false });
    }

    onChange = (e) => {
        this.setState({ exportType: e.target.value });
    }

    render() {
        const { visible, exportType } = this.state;
        return (
            <Modal
                title="导出"
                visible={visible}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                width="500px"
            >
                <div className="cont-cont" style={{ padding: '30px 20px' }}>
                    <div className="item" >
                        <label className="ui-label">请选择要导出内容：</label>
                    </div>
                    <div className="item">
                        <RadioGroup onChange={this.onChange} value={exportType}>
                            <div style={{ marginTop: 15 }}><Radio value="requirement">人员需求列表</Radio></div>
                            <div style={{ marginTop: 15 }}><Radio value="requirementDetail">人员需求FTE明细和人员资源</Radio></div>
                        </RadioGroup>
                    </div>
                </div>
            </Modal>
        );
    }
}

export default ExportModal;


// WEBPACK FOOTER //
// ./src/components/user/require/components/ExportModal.js